module.exports = __webpack_public_path__ + "dceab463ab2c3761c625173fc9cd38a4.png";